import { createContext, useContext, useEffect, useState } from "react";

const ViewModeContext = createContext({ mode: "auto", setMode: () => {} });

export function ViewModeProvider({ children }) {
  const [mode, setMode] = useState(() => { try { return localStorage.getItem("smartcafe_view_mode") || "auto"; } catch { return "auto"; } });
  useEffect(() => {
    try { localStorage.setItem("smartcafe_view_mode", mode); } catch { /* storage blocked (private mode / quota) — view mode just isn't remembered */ }
    const root = document.documentElement;
    root.classList.remove("force-desktop", "force-mobile");
    if (mode === "desktop") root.classList.add("force-desktop");
    if (mode === "mobile") root.classList.add("force-mobile");
  }, [mode]);
  return <ViewModeContext.Provider value={{ mode, setMode }}>{children}</ViewModeContext.Provider>;
}

export const useViewMode = () => useContext(ViewModeContext);
